import React from 'react';
import '../App.less';
import { Link } from "react-router-dom";
import { 
    Button,
    Image,
    Typography, 
    Divider, 
    Statistic,
    Tag,
    Row, 
    Col,
    Space,
    PageHeader,
    Avatar,
    Alert
} from 'antd';

import { AntDesignOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;



function flow() {
  return (
    <div>
        <Row className="m48-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <div>
                    <Row className="m24-b">
                        <Link to="/">
                            <PageHeader
                                onBack={() => null}
                                title="Back to Home"
                            />
                        </Link>
                    </Row>

                    <Row className="m16-b">
                        <Title>Flow</Title>
                    </Row>

                    <Row className="m24-b m24-t">
                        <Text>
                            Flow is a Behavioral design project focussing on water consciousness. This was a one day project and I wanted to explore if empathy could be transmitted to create a behaviour change.
                        </Text>  
                    </Row>

                    <Row justify="space-between">
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Advisors</Text>
                                <Text className="bitDesc">
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/alexandra-fiorillo-she-her-5b03124/" target="_blank" rel="noopener noreferrer">Alexandra Fiorillo</a>,
                                    <a className="nameLinkColor" href="https://www.linkedin.com/in/sarahfathallah/" target="_blank" rel="noopener noreferrer"> Sarah Fathallah</a>
                                </Text>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Team</Text>
                                <Text className="bitDesc">
                                    Individual
                                </Text>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Sustainable development goals</Text>
                                <Space className="m8-t">
                                    <Image className="sdgImage" src={`../pubAssets/sdg-11.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-12.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-13.png`}/>
                                    <Image className="sdgImage" src={`../pubAssets/sdg-14.png`}/>
                                </Space>
                            </Space>
                        </Col>
                        <Col xs={24} sm={24} md={24} lg={5} xl={5}>
                            <Space size={4} direction="vertical" className="m24-t">
                                <Text className="bitTitle">Tags</Text>
                                <Space size={1}>
                                    <Tag>Processing</Tag>
                                    <Tag>Projection Map</Tag>
                                </Space>
                                <Space size={1}>
                                    <Tag>API</Tag>
                                    <Tag>CIID</Tag>
                                </Space>
                            </Space>
                        </Col>
                    </Row>

                    
                </div>
            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>

        <Row>
        <Col span={24}>
                <div className="videoHeight">
                    <iframe src="https://player.vimeo.com/video/509609981?title=0&byline=0&portrait=0" className="vimeoChild" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
                </div>
        </Col>  
        </Row>
        
        <Row className="m80-t m80-b">
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
            <Col xs={22} sm={22} md={22} lg={18} xl={18}>
                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Space size={4} direction="vertical">
                            <Text className="projectTitle">challenge</Text>
                            <Text>
                                <ul>
                                    <li><strong>Problem:</strong> Wastage of water in households</li>
                                    <li><strong>Hypothesis:</strong> A person doesn’t understand the enormity of their micro-actions as they can’t see any immediate effects</li>
                                    <li><strong>Cognitive biases:</strong> Intention-Action Gap, Status Quo and Present biases</li>
                                    <li><strong>Intervention moment:</strong> Every time water is used</li>
                                </ul>
                            </Text>
                        </Space>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={11} xl={11}>
                        <Space size={4} direction="vertical">
                            <Text className="projectTitle">outcome</Text>
                            <Text>
                                <ul>
                                    <li><strong>Intervention:</strong> Reflecting the amount of water used by a person as the water drained away from a fish bowl</li>
                                    <li><strong>Behavioral design strategies:</strong> Reminding of intentions, appeal to future desires or intentions. Encourage trying something new</li>
                                    <li><strong>Behavioral outcome:</strong> Judicious use of water</li>
                                </ul>
                            </Text>
                        </Space>
                    </Col>
                </Row>
                
                <Row className="m80-t">
                    <Text className="projectTitle">Prototype</Text>
                    <Text className="m16-t m16-b">Like a painting is treasured in a house, I wanted to experiment how would it feel like to make that space more meaningful. Selected a painting in a photo frame in my house and covered with white paper.</Text>
                    
                </Row>
                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                        <div>
                            <Image className="m24-t" src={require("../assets/projects/flow/flow_3.gif")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    Started off with experimenting basic projection - simulation of fluid using basic GIFs
                                </Text>
                            </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                        <div>
                            <Image className="m24-t" src={require("../assets/projects/flow/flow_1.gif")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    Trying out different fish simulations - This one was made in WEBGL which I found online.
                                </Text>
                            </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                        <div>
                            <Image className="m24-t" src={require("../assets/projects/flow/flow_2.gif")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    Could I use animated fishes in p5?
                                </Text>
                            </div>
                        </div>
                    </Col>
                </Row>

                <Row justify="space-between">
                    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                        <div>
                            <Image className="m24-t" src={require("../assets/projects/flow/flow_5.gif")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    open source p5 sketch I found to test number of fishes and water-level behaviour.
                                </Text>
                            </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                        <div>
                            <Image className="m24-t" src={require("../assets/projects/flow/flow_4.gif")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    Running a calculated simulation in after effects to see how it feels like when the water level goes down.
                                </Text>
                            </div>
                        </div>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={7} xl={7}>
                        <div>
                            <Image className="m24-t" src={require("../assets/projects/flow/flow_6.gif")}/>
                            <div  className="m16-t">
                                <Text className="imgDesc">
                                    What other elements can complement this and make it more informative, i.e. number of days, water left etc.
                                </Text>
                            </div>
                        </div>
                    </Col>
                </Row>

            </Col>
            <Col xs={1} sm={1} md={1} lg={3} xl={3}></Col>
        </Row>

        <Row className="m80-t m80-b">
            <Col span={3}></Col>
            <Col span={18}>

                <Row>
                    <Text className="projectTitle">Learnings from prototype</Text>
                </Row>

                <Row justify="space-between m16-t">
                    <Col span={24}>
                        <Space size={4} direction="vertical">
                            <Text>
                                Since there was no time to test this, here is what I learned and how I would test I was able to.
                                <ul>
                                    <li>Ask people to use water for different purposes and see their reaction to the intervention</li>
                                    <li>See reaction to people realising how much water is used for different tasks.</li>
                                    <li>It’s not easy to modify routines.</li>
                                    <li>Important to reduce time between intention and action.</li>
                                    <li>Intrinsic and Extrinsic motivation really stood out to me, basis for any behaviour.</li>
                                    <li>Seeing the water level go down for the fish makes my heart cry.</li>
                                </ul>
                            </Text>
                        </Space>
                    </Col>
                </Row>

            </Col>
            <Col span={3}></Col>
        </Row>
    </div>
  );
}

export default flow;